import type { TechniqueEntry } from '../schema';

// review: applies_to is a proposed default — the doc's open authoring question asks whether base
// may reach scripted journey-composed opening moves live, or whether they stay journey-only until
// evidence says otherwise.
export const typicalDayWalkthrough: TechniqueEntry = {
  key: 'typical_day_walkthrough',
  version: '0.1',
  name: 'Typical day walk-through',
  pillar: 'MI',
  serves:
    'Coming to genuinely know a member (their days, their story, and where their use sits inside them) before any change work has begun. Understanding is the outcome, not a means to one.',
  method: [
    'Open with their life, never their substance. Four beats, in order: an ordinary workday start to finish (setting, people, how it starts, how rested they wake, the evening, getting to sleep); a typical weekend day, curious about what changes between the two; one concrete recent occasion (what it looked like, roughly how much or how long, whether it stayed what they planned or grew); fun and leisure, including anything they used to love that has quietly fallen away.',
    'Let use enter when they bring it: walking through real days, almost everyone places it unprompted; if it has not surfaced by the end of the weekend-day picture, bridge from something they already described rather than changing the subject to it.',
    'Sleep quality is a required touchpoint: if not genuinely surfaced (a bedtime is not sleep quality), ask directly: one question, one follow-up, no indirection needed.',
    "At most two follow-ups per thread, then reflect, connect, move. Bank rich off-beat threads: reflect once, name it as next time's material, return. Prefer one concrete story over ten general questions.",
    'Delivery: OARS, one question per turn, member owns the content, Sona owns the itinerary; depth flexes for emotional moments, the beat sequence and close do not.',
  ],
  never: [
    'No plan. No goal-setting. No steering toward change.',
    'Do not raise their use first.',
    'Never drop the close (the member leaves with one thing to do: at most a self-voiced observation to carry, never a change plan Sona supplied; do not manufacture a commitment).',
  ],
  // Opening move — consumes no personalisation by design (absorption phase).
  requiresFirst: [],
  doneWhen:
    'The member described real days in their own words, and at least one pattern surfaced: where use sits in the rhythm of the week, what a typical occasion actually amounts to, a time it grew past the plan, the cost to the day after, or something loved that has faded.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source: 'shared/sections/welcome_objective.md, welcome_context.md',
};
